
<v-content>
  <v-row class="layout" wrap>
    <v-col cols="12">
      <div v-show="loading" class="loading">
        <v-progress-circular
            :size="70"
            :width="7"
            class="animation"
            color="primary"
            indeterminate
        />
      </div>
      <v-alert :value="success" type="success">{{ $t("NEWSLETTER_UNREGISTERED_SUCCESSFULLY") }}</v-alert>
      <v-alert :value="error" type="info">{{ $t("NEWSLETTER_NOT_REGISTERED") }}</v-alert>
    </v-col>
  </v-row>
</v-content>

